import React, { useRef } from "react";
import { UploadCloud } from "lucide-react";

const BulkUploadSection = ({
  handleFileUpload,
  uploadError,
  uploadItems,
  handleAddAllItems,
}) => {
  const fileInputRef = useRef();
  return (
    <div className="mb-4 p-3 bg-blue-50 rounded-lg border border-blue-100 flex flex-col gap-2">
      <div className="flex items-center gap-2 mb-1 max-w-xs">
        <UploadCloud className="w-4 h-4 text-blue-500" />
        <span className="font-semibold text-blue-700 text-sm">
          Bulk Upload (CSV/Excel)
        </span>
      </div>
      <div className="flex items-center gap-2 max-w-xs">
        <button
          type="button"
          onClick={() => fileInputRef.current && fileInputRef.current.click()}
          className="px-3 py-1.5 bg-blue-600 hover:bg-blue-700 text-white rounded text-xs font-medium flex items-center gap-1"
        >
          <UploadCloud className="w-3 h-3" />
          Select File
        </button>
        <input
          ref={fileInputRef}
          type="file"
          accept=".csv,.json,.xlsx,.xls,.pdf"
          onChange={handleFileUpload}
          className="hidden"
        />
        <span className="text-xs text-gray-500">
          {uploadItems.length === 0 ? "No file" : `${uploadItems.length} ready`}
        </span>
      </div>
      {uploadError && (
        <div className="text-red-600 text-xs mb-1 max-w-xs">{uploadError}</div>
      )}
      {uploadItems.length > 0 && (
        <div className="bg-white rounded p-2 border border-gray-200 mt-1 w-full overflow-x-auto">
          <div className="text-xs text-gray-700 mb-1">Preview:</div>
          <table className="w-full text-xs">
            <thead>
              <tr className="bg-gray-50">
                <th className="px-2 py-1">Name</th>
                <th className="px-2 py-1">Price</th>
                <th className="px-2 py-1">Category</th>
              </tr>
            </thead>
            <tbody>
              {uploadItems.map((item, idx) => (
                <tr key={idx} className="border-b last:border-0">
                  <td className="px-2 py-1">{item.name}</td>
                  <td className="px-2 py-1">{item.price}</td>
                  <td className="px-2 py-1">{item.category}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <button
            onClick={handleAddAllItems}
            className="mt-2 px-3 py-1.5 bg-emerald-600 hover:bg-emerald-700 text-white rounded text-xs font-semibold"
          >
            Add All Items
          </button>
        </div>
      )}
    </div>
  );
};

export default BulkUploadSection;
